import { z } from "zod";
import { TopolColorSchema, TopolColorBearingSchema } from "../commonSchema";
import shortid from "shortid";
import { TopolColumnSchema } from "./columnSchema";
export * from "./columnSchema";

export const TopolSectionStyleAttributesSchema = z.object({
  "full-width": z.string().or(z.boolean()).optional().catch(undefined),
  padding: z.string().optional().catch(undefined),
  "background-color": TopolColorSchema.optional().catch(undefined),
  "in-group": z.boolean().optional().catch(undefined),
  "background-url": z.string().nullable().optional().catch(undefined),
  "background-size": z.string().optional().catch(undefined),
  "background-repeat": z.string().optional().catch(undefined),
  border: TopolColorBearingSchema.optional().catch(undefined),
  "border-right": TopolColorBearingSchema.optional().catch(undefined),
  "border-top": TopolColorBearingSchema.optional().catch(undefined),
  "border-left": TopolColorBearingSchema.optional().catch(undefined),
  "border-bottom": TopolColorBearingSchema.optional().catch(undefined),
  "border-radius": z.string().optional().catch(undefined),
  gradient: TopolColorBearingSchema.optional().catch(undefined),
});

export const TopolSectionSchema = z.object({
  tagName: z.literal("mj-section"),
  attributes: z
    .object({
      ...TopolSectionStyleAttributesSchema.shape,
      "mj-class": z.string().optional().catch(undefined),
      containerWidth: z.number().optional().catch(undefined),
      "css-class": z.string().nullable().optional().catch(undefined),
      locked: z.coerce.boolean().optional().catch(undefined),
    })
    .catch({}),
  children: TopolColumnSchema.array()
    .min(1)
    .catch([
      {
        tagName: "mj-column",
        attributes: {
          width: "100%",
          "vertical-align": "top",
        },
        children: [],
        uid: shortid.generate(),
      },
    ]),
  layout: z.number().catch(1),
  backgroundColor: z.string().nullish().catch(undefined),
  backgroundImage: z.string().nullish().catch(undefined),
  paddingTop: z.number().or(z.string()).optional().catch(undefined),
  paddingBottom: z.number().or(z.string()).optional().catch(undefined),
  paddingLeft: z.number().or(z.string()).optional().catch(undefined),
  paddingRight: z.number().or(z.string()).optional().catch(undefined),
  uid: z.string().catch(() => shortid.generate()),
  syncedId: z.number().optional().catch(undefined),
  syncedLang: z.string().optional().catch(undefined),
  aiGenerateContent: z.string().nullish().catch(undefined),
});
